import { render, staticRenderFns } from "./DoctorPersonTable.vue?vue&type=template&id=05c4cd8b"
import script from "./DoctorPersonTable.vue?vue&type=script&lang=js"
export * from "./DoctorPersonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports